import script from "./ProfileStudentResearch.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileStudentResearch.vue?vue&type=script&setup=true&lang=js"

import "./ProfileStudentResearch.vue?vue&type=style&index=0&id=695f9320&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-695f9320"]])

export default __exports__